/*
 * Maria Elena Headpieces — Product card (snippets/meh-product-card.liquid)
 * - Color swatches: change photo, price, color name, link and the variant to add.
 * - Add to cart: adds without leaving the page, then opens the theme's cart drawer,
 *   goes to the cart page, or stays (set in the grid section: "After adding to cart").
 */
(function () {
  'use strict';
  if (window.__mehProductCard) return;
  window.__mehProductCard = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-meh-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-meh-card]');
    if (card) selectSwatch(card, sw);
  });

  /* Hovering a swatch previews that color's photo; leaving restores the current photo */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-meh-swatch]');
    if (!sw || !sw.dataset.src) return;
    var card = sw.closest('[data-meh-card]');
    if (card) showImage(card, sw.dataset.src, sw.dataset.srcset, true);
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('[data-meh-card]');
    if (!card) return;
    var to = e.relatedTarget;

    /* Leaving the whole card: always go back to the product's first photo.
       The chosen color stays selected for price and Add to cart. */
    if (!to || !card.contains(to)) {
      showBase(card);
      return;
    }

    /* Leaving a swatch but still on the card: show the chosen color again */
    var sw = e.target.closest('[data-meh-swatch]');
    if (sw && !sw.contains(to)) restoreImage(card);
  });

  function showBase(card) {
    var img = primaryImg(card);
    if (!img) return;
    if (img.dataset.baseSrcset) img.srcset = img.dataset.baseSrcset; else img.removeAttribute('srcset');
    img.src = img.dataset.baseSrc;
    card.classList.remove('is-swatch-preview', 'is-color-chosen');
  }

  function primaryImg(card) {
    var img = card.querySelector('.meh-cg__img--primary');
    if (img && !img.dataset.baseSrc) {
      img.dataset.baseSrc = img.currentSrc || img.src;
      img.dataset.baseSrcset = img.getAttribute('srcset') || '';
    }
    return img;
  }

  function showImage(card, src, srcset, preview) {
    var img = primaryImg(card);
    if (!img || !src) return;
    if (srcset) img.srcset = srcset; else img.removeAttribute('srcset');
    img.src = src;
    card.classList.toggle('is-swatch-preview', !!preview);
  }

  function restoreImage(card) {
    var img = primaryImg(card);
    if (!img) return;
    var src = img.dataset.chosenSrc || img.dataset.baseSrc;
    var srcset = img.dataset.chosenSrc ? img.dataset.chosenSrcset : img.dataset.baseSrcset;
    if (srcset) img.srcset = srcset; else img.removeAttribute('srcset');
    img.src = src;
    card.classList.remove('is-swatch-preview');
    if (img.dataset.chosenSrc) card.classList.add('is-color-chosen');
  }

  function selectSwatch(card, sw) {
    var d = sw.dataset;

    card.querySelectorAll('[data-meh-swatch]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === sw));
    });

    var img = primaryImg(card);
    if (img && d.src) {
      img.dataset.chosenSrc = d.src;
      img.dataset.chosenSrcset = d.srcset || '';
      showImage(card, d.src, d.srcset, false);
    }
    card.classList.add('is-color-chosen');

    var price = card.querySelector('[data-meh-price]');
    if (price && d.price) price.textContent = d.price;

    var color = card.querySelector('[data-meh-color]');
    if (color) color.textContent = d.color || '';

    var input = card.querySelector('[data-meh-variant-input]');
    if (input) input.value = d.variantId;

    if (d.url) {
      card.querySelectorAll('[data-meh-link]').forEach(function (a) { a.href = d.url; });
    }

    var btn = card.querySelector('button.meh-cg__atc-btn');
    var label = card.querySelector('[data-meh-atc-label]');
    if (btn) {
      var ok = d.available === 'true';
      btn.disabled = !ok;
      if (label) label.textContent = ok ? card.dataset.atcLabel : card.dataset.soldOutLabel;
    }
  }

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-meh-atc]');
    if (!form) return;
    e.preventDefault();

    var card = form.closest('[data-meh-card]');
    var btn = form.querySelector('button');
    var label = form.querySelector('[data-meh-atc-label]');
    var input = form.querySelector('[data-meh-variant-input]');
    if (!card || !btn || !input || btn.disabled) return;

    var mode = card.dataset.afterAdd || 'drawer';

    /* Dawn-style themes: <cart-drawer> or <cart-notification> with renderContents() */
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var canRender = mode === 'drawer' && drawer &&
      typeof drawer.renderContents === 'function' &&
      typeof drawer.getSectionsToRender === 'function';

    var body = { id: Number(input.value), quantity: 1 };
    if (canRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    btn.disabled = true;
    card.classList.add('is-adding');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add');

        if (mode === 'cart_page') {
          window.location.href = root + 'cart';
          return;
        }

        if (canRender) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        }

        announce(res.json);
        refreshCount();
        flash(label, card.dataset.addedLabel, card.dataset.atcLabel);
      })
      .catch(function (err) {
        flash(label, err.message, card.dataset.atcLabel, 3200);
      })
      .finally(function () {
        btn.disabled = false;
        card.classList.remove('is-adding');
      });
  });

  function flash(label, text, back, ms) {
    if (!label) return;
    label.textContent = text;
    clearTimeout(label._mehT);
    label._mehT = setTimeout(function () { label.textContent = back; }, ms || 2200);
  }

  /* Let the theme and apps know the cart changed */
  function announce(item) {
    var detail = { item: item, source: 'meh-product-card' };
    ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:change', 'ajaxProduct:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    });
  }

  /* Update common cart-count elements in the header */
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        var sel = [
          '[data-cart-count]',
          '.cart-count',
          '.cart-count-bubble span[aria-hidden="true"]',
          '.cart-item-count',
          '.header__cart-count',
          '.js-cart-count'
        ].join(',');
        document.querySelectorAll(sel).forEach(function (el) {
          el.textContent = n;
          el.hidden = n === 0;
        });
      })
      .catch(function () {});
  }
})();
